<template>
    <div>
        <Language v-model="form.lang" @change="handleLangChange"></Language>
        <el-form size="mini" label-width="100px">
            <el-form-item label="标题">{{ form.name }}</el-form-item>
            <el-form-item label="关键词">{{ form.keyword }}</el-form-item>
            <el-form-item label="分类">{{ form.category.name }}</el-form-item>
            <el-form-item label="上传文件">{{ form.file_name }}</el-form-item>
            <el-form-item label="下载地址">{{ downloadUrl }}</el-form-item>
        </el-form>
    </div>
</template>

<script>
import Language from "@/components/Language";
import { detail } from "@/api/file/list";
import { ossUrl } from "@/configs/oss";
export default {
    components: { Language },
    data() {
        return {
            ossUrl,
            form: {
                lang: "zh",
                category: {},
            },
        };
    },
    mounted() {
        this.form.cuuid = this.$route.query.cuuid;
        this.getDetail();
    },
    computed: {
        downloadUrl() {
            return this.form.url ? (this.form.url.startsWith("http") ? this.form.url : `${this.ossUrl}${this.form.url}`) : "";
        },
    },
    methods: {
        handleLangChange() {
            this.getDetail();
        },
        getDetail() {
            detail({ cuuid: this.form.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form = { ...result, category: result.category ? result.category : {} };
                    } else {
                        this.form = { lang: this.form.lang, cuuid: this.form.cuuid, category: {} };
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>

<style></style>
